import { useState } from 'react';
import { assemblyService } from 'services/api';
import styles from './OrdenDiaButton.module.css';

const ORDEN_DIA_MAX = 5000;

// Botón + modal para fijar el orden del día de una asamblea sin abrir el
// formulario completo (petición de Marlon). Guarda su propio estado.
export default function OrdenDiaButton({ assembly, onSaved }) {
  const [open,   setOpen]   = useState(false);
  const [text,   setText]   = useState(assembly.orden_del_dia || '');
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState('');
  const tiene = !!(assembly.orden_del_dia && assembly.orden_del_dia.trim());

  const save = async () => {
    setSaving(true); setError('');
    try {
      await assemblyService.setOrdenDelDia(assembly.id, text);
      onSaved?.(assembly.id, text);
      setOpen(false);
    } catch (err) {
      setError(err.response?.data?.message || 'No se pudo guardar.');
    } finally { setSaving(false); }
  };

  return (
    <>
      <button
        className={`btn btn-sm btn-secondary btn-icon ${tiene ? styles.botonConOrden : ''}`}
        onClick={() => { setText(assembly.orden_del_dia || ''); setOpen(true); }}
        title={tiene ? 'Editar orden del día' : 'Agregar orden del día'}
        aria-label="Orden del día">
        <i className="fas fa-list-check" />
      </button>
      {open && (
        <div className="modal-overlay" onClick={() => setOpen(false)}>
          <div className={`modal ${styles.modalOrden}`} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3><i className={`fas fa-list-check ${styles.iconoTitulo}`} />
                Orden del día — Asamblea #{assembly.number_assembly}</h3>
              <button className="btn-close" onClick={() => setOpen(false)}>✕</button>
            </div>
            <div className="modal-body">
              {error && <div className={`alert alert-danger ${styles.aviso}`}>{error}</div>}
              <label className="form-label">Puntos a tratar (uno por línea)</label>
              <textarea className="form-control" rows="7" value={text} maxLength={ORDEN_DIA_MAX}
                onChange={e => setText(e.target.value)}
                placeholder={'1. Verificación del quórum\n2. Aprobación del acta anterior\n3. Informe de gestión\n4. Presupuesto\n5. Elección de consejo'} />
              <div className={styles.pie}>
                <span>Los propietarios lo ven en su panel durante la asamblea y precarga el acta.</span>
                <span>{text.length}/{ORDEN_DIA_MAX}</span>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setOpen(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={save} disabled={saving}>
                {saving ? <><i className="fas fa-spinner fa-spin" /> Guardando...</> : <><i className="fas fa-check" /> Guardar</>}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
